// probably timing problem with lit: https://github.com/lit/lit/blob/7453e365000e6a289c139cf7e175a4742296333d/packages/reactive-element/src/css-tag.ts#L10
// if lit is loaded before style sheet it cannot handle CSSStyleSheets from AdornisCSS
import 'construct-style-sheets-polyfill'; // THIS HAS TO BE THE FIRST IMPORT FOR FIREFOX TO WORK CORRECTLY

import { BaseQLClient } from '@adornis/baseql/client/baseqlClient.js';
import '@adornis/fonts/fonts.js';
import '@adornis/fonts/fontSrc/lato.js';
import '@adornis/fonts/fontSrc/maven-pro.js';
import { clientTranslator } from '@adornis/translation-core/client/clientTranslator.js';
import { Language } from '@adornis/translation-core/languages.js';
import { translations } from 'db/translations.js';
import '../db/index.js';
import './main-element.js';

clientTranslator.updateDictionary(translations, [Language.GERMAN, Language.ENGLISH]);

BaseQLClient.initDefault();
